// client/src/pages/user/Dashboard.js
import { useEffect, useState } from "react";
import api from "../../api/axiosInstance";
import { useAuth } from "../../context/AuthContext";

export default function Dashboard() {
  const { authUser } = useAuth();
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    api.get("/user/dashboard").then((res) => {
      setStats(res.data);
      setRecent(res.data.recent || []);
    });
  }, []);

  const balance = authUser?.user?.balance ?? 0;

  if (!stats) return <div>Loading…</div>;

  return (
    <div className="space-y-8">
      <h1 className="text-2xl font-bold">
        Welcome, {authUser?.user?.name}
      </h1>

      <div className="grid md:grid-cols-6 gap-4">
        <Stat label="Pending" value={stats.pending} />
        <Stat label="Processing" value={stats.processing} />
        <Stat label="Completed" value={stats.completed} />
        <Stat label="Cancelled" value={stats.cancelled} />
        <Stat label="Wallet Balance" value={`₹${balance}`} />
        <Stat label="Total Spent" value={`₹${stats.totalSpentAll}`} highlight />
      </div>

      <div className="card-glass p-4">
        <h2 className="font-semibold mb-3">Recent Orders</h2>

        {recent.length === 0 ? (
          <p className="text-gray-400">No recent orders</p>
        ) : (
          <table className="table-glass">
            <thead>
              <tr>
                <th>Service</th>
                <th>Qty</th>
                <th>Status</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {recent.map((o) => (
                <tr key={o._id}>
                  <td>{o.service?.name}</td>
                  <td>{o.quantity}</td>
                  <td>
                    <span className={`chip chip-${o.status}`}>
                      {o.status}
                    </span>
                  </td>
                  <td>₹{o.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

function Stat({ label, value, highlight }) {
  return (
    <div
      className={`card-glass p-4 ${
        highlight ? "bg-purple-600/30" : ""
      }`}
    >
      <div className="text-xs text-gray-400">{label}</div>
      <div className="text-xl font-bold">{value}</div>
    </div>
  );
}
